function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCourse = function SvgCourse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 70 70"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M70 35c0 19.3-15.7 35-35 35S0 54.3 0 35 15.7 0 35 0s35 15.7 35 35",
    className: "course_svg__st0",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5586f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4 18.4c-.8 0-1.5.7-1.5 1.5V47c0 1.7 2.8 4.5 4.5 4.5h24.5c.6 0 1.1-.7 1.1-1.5V23c0-.8-.5-1.5-1.1-1.5h-1.1v26.4c0 .8-.7 1.5-1.5 1.5h-20c-.6-.2-2.3-1.2-2.6-2.3h20.1c.8 0 1.5-.7 1.5-1.5V19.9c0-.8-.7-1.5-1.5-1.5zM26 37.3h6.8v-4.5H26zm13.5-12.8V29H26v-4.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }));
};
export default SvgCourse;